{
  "Call": "Call",
  "Email": "Email",
  "Directions": "Directions",
  "Users can click on this button to call your mobile number.": "Users can click on this button to call your mobile number.",
  "Users can tap this button to send you an email.": "Users can tap this button to send you an email.",
  "Got It": "Got It",
  "Location": "Location",
  "Directions will open in Google Maps. Do you want to continue?": "Directions will open in Google Maps. Do you want to continue?",
  "Show directions": "Show directions",
  "Use Google Maps": "Use Google Maps",
  "Waiting for you to enter data": "Waiting for you to enter data",
  "Where": "Where",
  "When": "When",
  "How would you like to save contact data?": "How would you like to save contact data?",
  "Save Contact Data": "Save Contact Data",
  "By tapping here, users are navigated to the linked social media profile or website.": "By tapping here, users are navigated to the linked social media profile or website.",
  "Mobile": "Mobile",
  "Website": "Website",
  "Social Media": "Social Media",
  "Telephone": "Telephone",
  "Fax": "Telephone",
  "Show on map": "Show on map",
  "Yes": "Yes",
  "No": "No",
  "Share page": "Share page",
  "Copied": "Copied",
  "Send by Email": "Send by Email",
  "Email was sent": "Email was sent",
  "Save to My Phone": "Save to My Phone",
  "Send contact details using email.": "Send contact details using email.",
  "Please look in your inbox, the email will arrive shortly.": "Please look in your inbox, the email will arrive shortly.",
  "Enter Email Address": "Enter Email Address",
  "Send": "Send",
  "Copy": "Copy",
  "Copy Code": "Copy Code",
  "Share": "Share",
  "Share this page": "Share this page",
  "Text copied to the clipboard.": "Text copied to the clipboard.",
  "Download vCard": "Download vCard",
  "Your visitors can click this button to download or send your vCard.": "Your visitors can click this button to download or send your vCard.",
  "25% OFF": "25% OFF",
  "Get coupon": "Get coupon",
  "Valid until": "Valid until",
  "Coupon Code": "Coupon Code",
  "Terms and Conditions": "Terms and Conditions",
  "Redeem now": "Redeem now",
  "Save Coupon Code": "Save Coupon Code",
  "View Location": "View Location",
  "Get Tickets": "Get Tickets",
  "Start": "Start",
  "End": "End",
  "All day": "All day",
  "Facility Features": "Facility Features",
  "About": "About",
  "Name": "Name",
  "Phone": "Phone",
  "Facebook": "Facebook",
  "Twitter": "Twitter",
  "Opening Hours": "Opening Hours",
  "Open Now": "Open Now",
  "Closed Now": "Closed Now",
  "Closed": "Closed",
  "...": "...",
  "Open": "Open",
  "Continue?": "Continue?",
  "Organizer": "Organizer",
  "Add event to calendar": "Add event to calendar",
  "Share event": "Share event",
  "Contact": "Contact",
  "Some QR Codes types will show a live preview here but not this one": "Some QR Codes types will show a live preview here but not this one.",
  "View and test your QR Code in the next step!": "View and test your QR Code in the next step!",
  "Read more": "Read more",
  "Show less": "Show less",
  "Waiting for you to enter a video": "Waiting for you to enter a video",
  "Joy's Cafe": "Joy's Cafe",
  "Eat. Refresh. Go": "Eat. Refresh. Go. ",
  "We aim to provide fresh and healthy snacks for people on the go.": "We aim to provide fresh and healthy snacks for people on the go.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit.": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "View menu": "View menu",
  "Mission Street": "Mission Street",
  "CA": "CA",
  "San Francisco": "San Francisco",
  "United States": "United States",
  "Joy": "Joy",
  "URL": "URL",
  "Instagram": "Instagram",
  "Jane Doe Agency": "Jane Doe Agency",
  "Jane": "Jane",
  "Doe": "Doe",
  "Designer": "Designer",
  "W 100th St ": "W 100th St",
  "New York  ": "New York",
  "NY": "NY",
  "Elle Boutique": "Elle Boutique",
  "Storewide Holiday Sale": "Storewide Holiday Sale",
  "Get all of your holiday shopping done early this year! Discounted items on all designer clothing, bags, and more.": "Get all of your holiday shopping done early this year! Discounted items on all designer clothing, bags, and more.",
  "17 Nov 2022": "17 Nov 2022",
  "18 Oct 2022": "18 Oct 2022",
  "(UTC)": "(UTC)",
  "Fairfield Ave": "Fairfield Ave",
  "PA": "PA",
  "Homestead": "Homestead",
  "lorem ipsum dolor sit amet consectetur adipiscing elit sed": "lorem ipsum dolor sit amet consectetur adipiscing elit sed",
  "(Music for Man ) Relaxing Whiskey Blues Music - Modern Electric Guitar Blues - JAZZ & BLUES": "(Music for Man ) Relaxing Whiskey Blues Music - Modern Electric Guitar Blues - JAZZ & BLUES",
  "Best Background Music 🎧 Chill music🎧 Party Mix 2022": "Best Background Music 🎧 Chill music🎧 Party Mix 2022",
  "JAZZ & BLUES": "JAZZ & BLUES",
  "ChillOut Music": "ChillOut Music",
  "WhatsApp": "WhatsApp",
  "Snapchat": "Snapchat",
  "Shop online": "Shop online",
  "WebVantage": "WebVantage",
  "Engaging Title": "Engaging Title",
  "Here we share awesome videos.": "Here we share awesome videos.",
  "Visit us online": "Visit us online",
  "www.your-website.com": "www.your-website.com",
  "Become a fan": "Become a fan",
  "YouTube": "YouTube",
  "Watch our videos": "Watch our videos",
  "Connect with us on Social Media": "Connect with us on Social Media",
  "Follow us and get updates delivered to your favorite social networks": "Follow us and get updates delivered to your favorite social networks",
  "Room": "Room",
  "Restaurant": "Restaurant",
  "Selection": "Selection",
  "Service": "Service",
  "Subcategory 1.1": "Subcategory 1.1",
  "Subcategory 1.2": "Subcategory 1.2",
  "Subcategory 1.3": "Subcategory 1.3",
  "Subcategory 1.4": "Subcategory 1.4",
  "Subcategory 2.1": "Subcategory 2.1",
  "Subcategory 2.2": "Subcategory 2.2",
  "Subcategory 3.1": "Subcategory 3.1",
  "Experiență excelentă!": "Experiență excelentă!",
  "Mâncare delicioasă!": "Mâncare delicioasă!",
  "Serviciu mediu.": "Serviciu mediu.",
  "Prețuri ridicate pentru calitatea oferită.": "Prețuri ridicate pentru calitatea oferită.",
  "Prețuri mici.": "Prețuri mici.",
  "Hotel": "Hotel",
  "Give us a feedback": "Give us a feedback",
  "Please select to review a category.": "Please select to review a category.",
  "Go to our website": "Go to our website",
  "Name this optional button as you want and link to any website of your choice.": "Name this optional button as you want and link to any website of your choice.",
  "How was your rental experience?": "How was your rental experience?",
  "Lake Cruisers": "Lake Cruisers",
  "Winter 2017 Lookbook": "Winter 2017 Lookbook",
  "Brrrr... the cold days are coming! Luckily, our new collection arrived just in time. Get your favourite styles before they're gone!": "Brrrr... the cold days are coming! Luckily, our new collection arrived just in time. Get your favourite styles before they're gone!",
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  "12 Jun 2023": "12 Jun 2023",
  "Sterling & Co": "Sterling & Co",
  "4th Annual Company Meetup": "4th Annual Company Meetup",
  "Meet fellow Sterlings and the 'people behind the jobs'": "Meet fellow Sterlings and the 'people behind the jobs'",
  "Come join Sterling & Co. at our annual company meetup! Get to know fellow Sterlings and enjoy team building activities.": "Come join Sterling & Co. at our annual company meetup! Get to know fellow Sterlings and enjoy team building activities.",
  "Sabaoani": "Sabaoani",
  "Progresului": "Progresului",
  "Neamt": "Neamt",
  "Romania": "Romania",
  "USA": "USA",
  "John Doe": "John Doe",
  "Eat. Refresh. Go.": "Eat. Refresh. Go.",
  "W 100th St": "W 100th St",
  "New York": "New York",
  "Message us": "Message us",
  "ID": "ID",
  "FACEBOOK": "FACEBOOK",
  "Shop now": "Shop now",
  "Whatsapp": "Whatsapp",
  "From my vCard": "From my vCard",
  "Copy Link": "Copy Link",
  "(Copied)": "(Copied)",
  "More": "More",
  "Menu": "Menu",
  "Your guests can click this button to quick add your event to their calendars.": "Your guests can click this button to quick add your event to their calendars.",
  "Choose your calendar format below.": "Choose your calendar format below.",
  "Google Calendar": "Google Calendar",
  "Apple Calendar": "Apple Calendar",
  "Outlook Online": "Outlook Online",
  "Yahoo! Calendar": "Yahoo! Calendar",
  "Watch on YouTube": "Watch on YouTube",
  "Less": "Less",
  "View PDF": "View PDF",
  "Go to our Page": "Go to our Page",
  "Go to our Facebook Page": "Go to our Facebook Page",
  "URL is not valid": "URL is not valid",
  "Close (Esc)": "Close (Esc)",
  "Toggle full-screen": "Toggle full-screen",
  "Zoom in/out": "Zoom in/out",
  "Previous (arrow left)": "Previous (arrow left)",
  "Next (arrow right)": "Next (arrow right)",
  "vcard": {
    "color1": "#455a64",
    "color2": "#e91e63",
    "color1b": "#ff0000",
    "avatar": { "bgColor": "#ffffff" },
    "welcome_screen": { "bgColor": "#ffffff" },
    "company": "Jane Doe Agency",
    "firstname": "Jane",
    "lastname": "Doe",
    "numbers_mobile": "+1-555-555-1234",
    "numbers_phone": "+1-555-555-0000",
    "email": "jane{'@'}email.com",
    "job": "Designer",
    "street_number": "",
    "number": "",
    "street": "W 100th St",
    "city": "New York",
    "state": "NY",
    "country": "United States",
    "zip": "10025",
    "website": "www.janedoe.com",
    "bio": "I am Jane Doe"
  },
  "app": {
    "app_store": "https://apps.apple.com/us/app/instagram/id389801252",
    "play_store": "https://play.google.com/store/apps/details?id=com.instagram.android",
    "amazon_store": "https://www.amazon.com/Instagram/dp/B00KZP2DTQ",
    "fallbackUrl": "",
    "button": {
      "label": "Learn more",
      "url": "https://www.instagram.com"
    },
    "name": "Instagram",
    "company": "Instagram, Inc.",
    "title": "Bringing you closer to the people and things you love.",
    "description": "Connect with friends, share what you’re up to, or see what's new from others all over the world. Explore our community where you can feel free to be yourself and share everything from your daily moments to life's highlights.",
    "website": "https://www.instagram.com"
  },
  "business": {
    "company": "Joy's Cafe",
    "headline": "Eat. Refresh. Go.",
    "teaser": "We aim to provide fresh and healthy snacks for people on the go.",
    "venue": "",
    "about": "Come join Sterling & Co. at our annual company meetup! Get to know fellow Sterlings and enjoy team building activities.",
    "callToAction": {
      "label": "View menu",
      "url": "http://www.joyscafe.com"
    },
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "United States",
    "name": "Joy",
    "phone": "(000) 000-0000",
    "email": "hello{'@'}joyscafe.com",
    "website": "http://www.joyscafe.com"
  },
  "url": {
    "url": ""
  },
  "text": {
    "text": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
  },
  "coupon": {
    "company": "Elle Boutique",
    "headline": "Storewide Holiday Sale",
    "name": "OFF25",
    "description": "Get all of your holiday shopping done early this year! Discounted items on all designer clothing, bags, and more.",
    "sale": "25% OFF",

    "website": {
      "label": "Redeem now",
      "url": "http://www"
    },
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "United States",
    "terms": "lorem ipsum dolor sit amet consectetur adipiscing elit sed"
  },
  "event": {
    "organizer": "Sterling & Co",
    "title": "4th Annual Company Meetup",
    "teaser": "Meet fellow Sterlings and the 'people behind the jobs'",
    "about": "Come join Sterling & Co. at our annual company meetup! Get to know fellow Sterlings and enjoy team building activities.",
    "venue": "",
    "street": "W 100th St",
    "street_number": "",
    "state": "NY",
    "zip": "10025",
    "city": "New York",
    "country": "United States",
    "contact": "John Doe",
    "phone": "(000) 000-0000",
    "email": "hello{'@'}sterling.com",
    "website": "http://www.sterling.com",
    "callToAction": {
      "label": "Get tickets",
      "url": "http://www.sterling.com"
    }
  },
  "video": {
    "callToAction": {
      "label": "Get yours",
      "url": "http://bit.ly/2IgdnXT"
    },
    "company": "Larq",
    "headline": "The World's First Self-Cleaning Water Bottle",
    "description": "The LARQ Bottle is the world's first self-cleaning water bottle and water purification system. It uses UV-C LED light to eliminate up to 99.9999% of bio-contaminants from your water and bottle."
  },
  "image": {
    "callToAction": {
      "label": "Learn More",
      "url": "https://ro.pinterest.com/mcsyniam/winter-lookbook/"
    },
    "title": "Winter 2023 Lookbook",
    "website": "",
    "description": "Brrrr... the cold days are coming! Luckily, our new collection arrived just in time. Get your favourite styles before they're gone!"
  },
  "social-media": {
    "headline": "Connect with us on Social Media",
    "description": "Follow us and get updates delivered to your favorite social networks",
    "website": { "value": "www.your-website.com", "text": "Visit us online" },
    "facebook": { "value": "www.facebook.com", "text": "Become a fan" },
    "youtube": { "value": "www.youtube.com", "text": "Watch our videos" }
  },
  "facebook": {
    "title": "Click on the Like Button to follow us on Facebook.",
    "facebookUrl": "https://www.facebook.com/facebook",
    "name": "Facebook",
    "website": "https://www.facebook.com"
  },
  "pdf": {
    "company": "Amazon",
    "title": "Toys We Love list",
    "description": "Amazon reveals the 2023 Toys We Love list, including 200 toys from brands like LEGO, Mattel, Magna-Tiles, and Disney",
    "website": "www.amazon.com"
  },
  "mp3": {
    "title": "Sanssouci",
    "info": "The Last Station",
    "website": "https://www.youtube.com/{'@'}laststationoficial",
    "callToAction": {
      "label": "Visit us online",
      "url": "https://www.youtube.com/{'@'}laststationoficial"
    }
  }
}
